import { ReactElement } from 'react'
import { H3 } from '../../typography'
import { BadgeProps } from './typings'
import { SubTitle, BadgeWrapper } from './subcomponents'

const Badge = ({ title, subTitle, width }: BadgeProps): ReactElement => {
  return (
    <BadgeWrapper width={width}>
      <H3>{title}</H3>
      <SubTitle>{subTitle}</SubTitle>
    </BadgeWrapper>
  )
}

export default Badge
